import { useRouteError } from 'react-router-dom';
import { ErrorFallback } from './ErrorFallback';

/**
 * Router errorElement — catches render/loader errors within a route and shows
 * the branded fallback instead of react-router's raw "Unexpected Application
 * Error" stack trace (AUT-180).
 */
export default function ErrorPage() {
  const error = useRouteError();
  if (error) console.error('Route error:', error);

  return <ErrorFallback />;
}
